import Quill from "quill/core";

import Keyboard from "quill/modules/keyboard";
import Toolbar from "quill/modules/toolbar";

import Bubble from "quill/themes/bubble";
import Snow from "quill/themes/snow";

import Bold from "quill/formats/bold";
import Italic from "quill/formats/italic";
import Strike from "quill/formats/strike";
import Link from "quill/formats/link";
import {BackgroundStyle} from "quill/formats/background";
import {ColorStyle} from "quill/formats/color";
import List from "quill/formats/list";

import bubbleAutoClose from "./bubbleAutoClose.js";
import debounce from "../utilities/debounce.js";
import blazorUpdate from "./blazorUpdate.js";
import delay from "../utilities/delay.js";

Quill.register({
    "modules/keyboard": Keyboard,
    "modules/toolbar": Toolbar,
    "themes/bubble": Bubble,
    "themes/snow": Snow,
    "formats/bold": Bold,
    "formats/italic": Italic,
    "formats/strike": Strike,
    "formats/link": Link,
    "formats/background": BackgroundStyle,
    "formats/color": ColorStyle,
    "formats/list": List,
});

const createInstance = async (element) => {
    if (element.dataset.quill === 'true') {
        return;
    }

    element.dataset.quill = 'true';
    await delay(100);

    const selection = window.getSelection();
    let cursorPosition = 0;
    if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const clonedRange = range.cloneRange();
        clonedRange.selectNodeContents(element);
        clonedRange.setEnd(range.endContainer, range.endOffset);
        cursorPosition = clonedRange.toString().length;
    }

    element.setAttribute("contenteditable", false);

    const quill = element.querySelector('.ra-quill');
    element._quill = new Quill(quill, {
        bounds: element,
        theme: element.dataset.theme,
        modules: {
            keyboard: {
                bindings: {
                    enter: {
                        key: 'Enter',
                        shiftKey: false,
                        handler: function () {
                            console.log('Enter pressed. ' + element.id);
                            element.dataset.submitOnBlur = 'true';
                            blazorUpdate(element);
                            return false;
                        }
                    },
                    tab: {
                        key: 'Tab',
                        handler: function () {
                            return true;
                        }
                    },
                }
            },
            toolbar: [
                ['bold', 'italic', 'strike'],
                ['link'],
                [{'color': []}, {'background': []}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                ['clean'],
            ]
        },
    });

    if (element.dataset.autofocus === 'true') {
        element._quill.setSelection(cursorPosition, 0);
    }

    if (element.dataset.theme === 'bubble') {
        bubbleAutoClose(element);
    }

    if (element.dataset.theme === 'snow') {
        const debounceUpdate = debounce(() => {
            blazorUpdate(element);
        });

        element._quill.on('text-change', debounceUpdate);
    }
};

export default createInstance;